// 所有表格行相同的配置
const columnPublicConfig = {
    align: 'center'
}

// 筛选器配置
const filterItemsConfig = {
    scopedSlots: {
        filterDropdown: 'filterDropdown',
        filterIcon: 'filterIcon'
    }
}

// 编辑内容配置
export const formModel = {
    j: {
        title: '数量',
        type: 'inputNumber',
        min: 1,
        max: 50,
        value: '',
        placeholder: '请输入数量，一次性最多生成50个卡号',
        rules: [{
            required: true,
            message: '请输入数量'
        }]
    },
    clip_typeid: {
        title: '卡类型',
        type: 'select',
        value: '',
        items: [],
        rules: [{
            required: true,
            message: '请选择卡类型'
        }]
    },
    title: {
        title: '卡号前缀',
        type: 'input',
        value: '',
        rules: [{
            required: true,
            message: '请输入卡号前缀'
        }]
    }
}

export const formModelActiveCard = {
    type: {
        title: '操作类型',
        type: 'select',
        value: '',
        items: [{
            id: '1',
            name: '分配'
        },
        {
            id: '2',
            name: '作废'
        }],
        rules: [{
            required: true,
            message: '请选择操作类型'
        }]
    },
    status: {
        title: '气站',
        type: 'select',
        value: '',
        items: [],
        rules: [{
            required: true,
            message: '请选择气站'
        }]
    },
    title: {
        title: '卡号前缀',
        type: 'select',
        value: '',
        items: [],
        rules: [{
            required: true,
            message: '请输入卡号前缀'
        }]
    },
    min: {
        title: '最小值',
        type: 'inputNumber',
        min: 0,
        value: '',
        rules: [{
            required: true,
            message: '请输入最小值'
        }]
    },
    max: {
        title: '最大值',
        type: 'inputNumber',
        min: 0,
        value: '',
        rules: [{
            required: true,
            message: '请输入最大值'
        }]
    }
}

// 表格配置
/**
 * title: 表格标题
 * dataIndex: 后端返回的这个标题的名字
 * filterIndex: 筛选器字段，一般和dataIndex一样，如果是选择型的筛选器，这里填写id字段
 * key: 随便选择dataIndex或filterIndex中的一个
 * type: 筛选器类型，input = 输入框，select = 选择框
 * multi: 如果选择型筛选器需要多选，就写上值为true
 * items: 选择型筛选器必须带上这个，默认为空数组
 */
export const columns = [{
    title: '类型',
    dataIndex: 'clip_typeid',
    filterIndex: 'clip_typeid',
    key: 'clip_typeid',
    type: 'select',
    items: [],
    ...columnPublicConfig,
    ...filterItemsConfig
},
{
    title: '卡号',
    dataIndex: 'card',
    key: 'card',
    ...columnPublicConfig,
},
{
    title: '卡状态',
    dataIndex: 'type',
    key: 'type',
    ...columnPublicConfig
},
{
    title: '所属气站',
    dataIndex: 'status',
    key: 'status',
    ...columnPublicConfig
},
{
    title: '用户状态',
    dataIndex: 'user_type',
    key: 'user_type',
    ...columnPublicConfig
},
{
    title: '经销商状态',
    dataIndex: 'admin_type',
    key: 'admin_type',
    ...columnPublicConfig
},
{
    title: '二维码',
    dataIndex: 'img',
    key: 'img',
    scopedSlots: {
        customRender: 'c-qrcode'
    },
    ...columnPublicConfig
},
    // {
    //     title: '操作',
    //     dataIndex: 'action',
    //     key: 'action',
    //     width: 160,
    //     scopedSlots: {
    //         customRender: 'c-action'
    //     }
    // }
]
